module.exports = __webpack_public_path__ + "static/media/19.a1dd2d37.jpg";